import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { OutputProcessingEventDetailsSchema } from '../schema/OutputProcessingEventDetailsSchema';
import { OutputProcessingEventDetailsType } from '../schema/types';
import { ProcessingEventUrl } from './ProcessingEventUrl';

const getOutputProcessingEvent = (
  id: number,
  processingDataObjectId?: number
) =>
  apiClient
    .get<OutputProcessingEventDetailsType>(
      expand(ProcessingEventUrl.OUTPUT_PROCESSING_EVENT, {
        id,
        processingDataObjectId,
      })
    )
    .then((response) =>
      OutputProcessingEventDetailsSchema.parse(response.data)
    );

export const useOutputProcessingEventQuery = createApiQueryHook(
  ['OutputProcessingEvent'],
  getOutputProcessingEvent
);
